<template>
  <div class="main-wrapper no-sidebar pos-layout">
    <!-- Header -->
    <Header />

    <div class="page-wrapper full-width">
      <div class="content no-padding">
        <router-view />
      </div>
    </div>

    <PosCalculatorModal />
  </div>
</template>

<script>
import Header from '../layouts/Header.vue';
import PosCalculatorModal from '@/components/common/PosCalculatorModal.vue';

export default {
  components: {
    Header,
    PosCalculatorModal,
  },
};
</script>
